import React, { useState, useEffect } from 'react'
import { DeleteOutlined } from '@ant-design/icons'
import { Button, Row, Col, Collapse, Typography } from 'antd'
import PropTypes from 'prop-types'

import { PriceSections } from '~components'
import { MultiSelectDropdown } from '~stories'

import styles from './PriceTemplateClass.module.css'

const { Panel } = Collapse
const { Text } = Typography

const PriceTemplateClass = ({
  availableClasses,
  currentClass,
  handleClassSelection,
  index,
  invalidPriceClasses,
  priceClassesCount,
  removePriceClass,
  selectedClasses,
  showSectionPriceError,
  updateMaxPriceByClassAndSection,
  updateMinPriceByClassAndSection,
  handleServiceFeeMaxPriceInput,
  handleServiceFeeMinPriceInput
}) => {
  const [sections, setSections] = useState([])
  const [currentClassName, setCurrentClassName] = useState('')

  useEffect(() => {
    if (currentClass) {
      setSections(currentClass.sections)
      setCurrentClassName(currentClass.name)
    }
  }, [currentClass])

  const removePriceClassFromTemplate = e => {
    e.stopPropagation()
    removePriceClass(index)
  }

  const onClassSelect = className => {
    handleClassSelection(index, className)
  }

  let availableClassesToSelect = availableClasses.filter(availableClass => !selectedClasses.includes(availableClass))

  availableClassesToSelect = currentClassName.length > 0
    ? [currentClassName, ...availableClassesToSelect]
    : availableClassesToSelect

  const options = availableClassesToSelect.map(priceClass => ({
    label: priceClass,
    value: priceClass
  }))

  const priceSectionList = sections.map((section, sectionIndex) => (
    <Col key={sectionIndex} className={styles.sectionTemplate} span={3}>
      <PriceSections
        key={`${section.name}_${sectionIndex}`}
        handleServiceFeeMaxPriceInput={handleServiceFeeMaxPriceInput}
        handleServiceFeeMinPriceInput={handleServiceFeeMinPriceInput}
        index={sectionIndex}
        maxPrice={section.max_price}
        minPrice={section.min_price}
        name={section.name}
        priceClassIndex={index}
        serviceFee={section.service_fee ?? {}}
        showSectionPriceError={showSectionPriceError}
        updateMaxPrice={updateMaxPriceByClassAndSection}
        updateMinPrice={updateMinPriceByClassAndSection}
      />
    </Col>
  ))

  const showError = currentClassName !== '' && invalidPriceClasses.includes(currentClassName)

  const panelHeader = (
    <div className={styles.panelHeader}>
      <span className={styles.panelTitle}>
        {currentClassName || 'Select Price Class'}
      </span>
      {/* <span className={styles.sectionCount}>
        {sections.length} section{sections.length !== 1 ? 's' : ''}
      </span> */}
      {showError && <Text className={styles.errorText} type='danger'>*Invalid price range</Text>}
    </div>
  )

  const extraActions = priceClassesCount > 1
    ? <Button className={styles.removeButton} danger icon={<DeleteOutlined />} onClick={removePriceClassFromTemplate} size="small" type="text">Remove</Button>
    : null

  return (
    <Collapse className={styles.priceClassCollapse} defaultActiveKey={[`panel_${index}`]}>
      <Panel key={`panel_${index}`} extra={extraActions} header={panelHeader}>
        <div className={styles.classSelector}>
          <MultiSelectDropdown displayField='label' dropdownOptions={options} handleChange={onClassSelect} selectedItems={currentClassName} valueField='value' />
        </div>
        <Row className={styles.sectionsRow}>
          {priceSectionList}
        </Row>
      </Panel>
    </Collapse>
  )
}

PriceTemplateClass.propTypes = {
  availableClasses: PropTypes.array.isRequired,
  currentClass: PropTypes.object.isRequired,
  handleClassSelection: PropTypes.func.isRequired,
  handleServiceFeeMaxPriceInput: PropTypes.func.isRequired,
  handleServiceFeeMinPriceInput: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  invalidPriceClasses: PropTypes.array,
  priceClassesCount: PropTypes.number.isRequired,
  removePriceClass: PropTypes.func.isRequired,
  selectedClasses: PropTypes.array.isRequired,
  showSectionPriceError: PropTypes.bool.isRequired,
  updateMaxPriceByClassAndSection: PropTypes.func.isRequired,
  updateMinPriceByClassAndSection: PropTypes.func.isRequired
}

PriceTemplateClass.defaultProps = {
  availableClasses: [],
  currentClass: {
    sections: [],
    name: ''
  }
}

export default PriceTemplateClass
